import { MenuList } from '@mui/material';
import React from 'react';

import { BackNavigation } from '../../MobileNavBar/Components/BackNavigation';
import { MobileMenuItem } from '../../MobileNavBar/Components/MobileMenuItem';
import { UtilityTrayMenuItem } from '../../types';

import { DATA_OG, DATA_TEST, getDynamicDataOGId, getDynamicDataTestId } from '../../enums';

interface IMobileUtilitySubmenuProps {
  optionLabel: string;
  options: UtilityTrayMenuItem[];
  firstTrayMenuItemRef?: React.MutableRefObject<HTMLLIElement>;
  showMainMenu(): void;
  closeUtilityMenu(): void;
}
export const MobileUtilitySubmenu: React.FC<IMobileUtilitySubmenuProps> = ({
  optionLabel,
  options,
  showMainMenu,
  closeUtilityMenu,
  firstTrayMenuItemRef
}) => {
  return (
    <MenuList data-test={getDynamicDataTestId(DATA_TEST.mobile_utility_submenu_container, optionLabel.toLowerCase())}>
      <BackNavigation onClick={showMainMenu} title={optionLabel} />
      {options.map((option, idx: number) => {
        return (
          <MobileMenuItem
            firstTrayMenuItemRef={idx === 0 ? firstTrayMenuItemRef : undefined}
            autoFocus={idx === 0}
            key={option.label}
            item={{
              url: option.url,
              label: option.label,
              id: '',
              openInNewTab: option.openInNewTab,
              linkComponent: option.linkComponent
            }}
            handleClick={() => {
              option.onClick?.();
              closeUtilityMenu();
            }}
            dataTest={getDynamicDataTestId(
              option.url ? DATA_TEST.mobile_utility_menu_item_link : DATA_TEST.mobile_utility_menu_item,
              option.label.toLowerCase()
            )}
            dataOG={getDynamicDataOGId(DATA_OG.mobile_utility_menu_link, option.label.toLowerCase())}
            showIcon={false}
          />
        );
      })}
    </MenuList>
  );
};
